import MarketingPageLayout from "../components/MarketingPageLayout";
import SeoHelmet from "../components/SeoHelmet";
import MarketingHero from "../components/MarketingHero";
import FeatureList from "../components/FeatureList";
import InternalLinks from "../components/InternalLinks";
import CtaFinal from "../components/CtaFinal";
import { MARKETING_META } from "../seoMeta";
import { buildWebPageLd } from "../../shared/seoJsonLd";
import useTranslation from "../../client/hooks/useTranslation";

const PATH = "/solutions/coach-trading";

export default function SolutionCoachPage() {
  const t = useTranslation();
  const m = MARKETING_META[PATH];
  const c = t.marketing.solutions.coach;
  return (
    <MarketingPageLayout>
      <SeoHelmet
        path={PATH}
        title={m.title}
        description={m.description}
        jsonLd={[buildWebPageLd({ name: m.title, description: m.description, path: PATH })]}
      />
      <MarketingHero h1={c.h1} subtitle={c.subtitle} />
      <FeatureList items={c.bullets} />
      <InternalLinks
        links={[
          { to: "/tarifs", label: t.marketing.nav.pricing },
          { to: "/fonctionnalites/mode-mentor", label: t.marketing.nav.megaFeatures[4].label },
        ]}
      />
      <CtaFinal />
    </MarketingPageLayout>
  );
}
